import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { DELETE } from '../../../../config/permissions';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { generateDeleteBusMaintenaceStayPath } from '../../../../config/endpoints';

const BusMaintenanceStayDeleteButton = ({
  maintenanceStay,
  handleMarkForDelete,
}) => {
  const isMarkedForDelete = maintenanceStay.markedForDelete;

  return (
    <>
      <Button
        color={isMarkedForDelete ? 'secondary' : 'danger'}
        outline
        className="mr-3"
        onClick={() => handleMarkForDelete(maintenanceStay)}
        title={
          isMarkedForDelete ? 'Desmarcar eliminación' : 'Marcar para eliminar'
        }
      >
        <i className={isMarkedForDelete ? 'fa fa-undo' : 'fa fa-trash'} />
      </Button>
    </>
  );
};

BusMaintenanceStayDeleteButton.propTypes = {
  maintenanceStay: PropTypes.shape({
    estimatedCompletionDate: PropTypes.string,
    markedForDelete: PropTypes.bool,
  }).isRequired,
  handleMarkForDelete: PropTypes.func.isRequired,
};

BusMaintenanceStayDeleteButton.defaultProps = {};

export default withEndpointAuthorization({
  url: generateDeleteBusMaintenaceStayPath(0),
  permissionType: DELETE,
})(BusMaintenanceStayDeleteButton);
